// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bic_h bic_kh bic_we bic_su bic_vt bic_sw bic_sn"};